import React, { useContext } from "react";
import Box from "@mui/material/Box";
import classNames from "classnames";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const colorClase = (color) =>
  classNames({
    rojo: color === "ROJO",
    amarillo: color === "AMARILLO",
    verde: color === "VERDE",
    azul: color === "AZUL",
    fuccia: color === "FUCCIA",
    naranja: color === "NARANJA",
    blanco: color === "BLANCO",
    negro: color === "NEGRO",
    celeste: color === "CELESTE",
    marron: color === "MARRON",
  });

const columns = [
  { field: "id", header: "ID", width: "7rem" },
  { field: "nombre", header: "Nombre" },
  {
    field: "color",
    header: "Color",
    width: "10rem",
    render: (row) => (
      <Box
        component="span"
        className={colorClase(row.color)}
        sx={{ px: 1, py: 0.25, borderRadius: 1, display: "inline-block", fontSize: 12 }}
      >
        {row.color}
      </Box>
    ),
  },
  { field: "servicio", header: "Tipo de servicio" },
  { field: "cuestionario", header: "Cuestionario", type: "bool", width: "9rem" },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "9rem" },
];

export default function MotivosConsultas() {
  const {
    motivosConsultas,
    colores,
    tiposServicios,
    obtenerMotivosConsultas,
    obtenerColores,
    obtenerTiposServicios,
    agregarMotivoConsulta,
    actualizarMotivoConsulta,
  } = useContext(ConfiguracionContext);

  const fields = [
    { name: "nombre", label: "Nombre", type: "text", required: true, md: 12 },
    {
      name: "colorId",
      label: "Color",
      type: "select",
      required: true,
      requiredMsg: "El color es necesario !.",
      options: colores || [],
      optionLabel: "nombre",
      optionValue: "id",
      md: 6,
    },
    {
      name: "servicioId",
      label: "Tipo de servicio",
      type: "select",
      required: true,
      requiredMsg: "El servicio es necesario !.",
      options: tiposServicios || [],
      optionLabel: "nombre",
      optionValue: "id",
      md: 6,
    },
    { name: "cuestionario", label: "Cuestionario", type: "switch", md: 6 },
    { name: "habilitado", label: "Habilitado", type: "switch", md: 6 },
  ];

  return (
    <MaestroArchivo
      titulo="Motivos de Consulta"
      entidad="motivo de consulta"
      layout="MotivosConsultas"
      icono={<ContactSupportOutlinedIcon />}
      items={motivosConsultas}
      listo={Boolean(colores && tiposServicios)}
      columns={columns}
      fields={fields}
      nuevoDefault={{
        nombre: "",
        colorId: null,
        servicioId: null,
        cuestionario: false,
        habilitado: true,
      }}
      onMount={() => {
        obtenerColores();
        obtenerTiposServicios();
      }}
      onObtener={() => obtenerMotivosConsultas({ todos: true })}
      onAgregar={(data) => agregarMotivoConsulta({ motivoConsulta: data })}
      onActualizar={(data) => actualizarMotivoConsulta({ motivoConsulta: data })}
    />
  );
}
